// Shared measurements for the resizable Agent Studio split.
//
// The Suggestions grid becomes two columns above 640px, so 641px is the exact
// default/requested chat width. Dragging may still take the chat down to 468px;
// the live app panel always keeps its 280px floor.
export const CHAT_DRAG_MIN_WIDTH = 468
export const SUGGESTIONS_TWO_COLUMN_MIN_WIDTH = 641
export const PANEL_MIN_WIDTH = 280
export const RESIZE_HANDLE_WIDTH = 5

function finiteWidth(value, fallback = 0) {
  const width = Number(value)
  return Number.isFinite(width) ? width : fallback
}

export function clampPanelWidth(bodyWidth, proposedPanelWidth) {
  const body = finiteWidth(bodyWidth)
  const proposed = finiteWidth(proposedPanelWidth, PANEL_MIN_WIDTH)
  const maxPanel = body - RESIZE_HANDLE_WIDTH - CHAT_DRAG_MIN_WIDTH
  return Math.max(PANEL_MIN_WIDTH, Math.min(proposed, maxPanel))
}

export function panelWidthForChat(
  bodyWidth,
  desiredChatWidth = SUGGESTIONS_TWO_COLUMN_MIN_WIDTH,
) {
  const body = finiteWidth(bodyWidth)
  const desiredChat = finiteWidth(
    desiredChatWidth,
    SUGGESTIONS_TWO_COLUMN_MIN_WIDTH,
  )
  return clampPanelWidth(body, body - RESIZE_HANDLE_WIDTH - desiredChat)
}
